import React from 'react';
import Icon from '../../../components/AppIcon';

const EmptyState = ({ onAdjustFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <Icon name="Briefcase" size={48} color="#9CA3AF" />
      </div>
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">No More Opportunities</h2>
      <p className="text-gray-600 text-center mb-8 max-w-md">
        Check back later for new opportunities that match your profile.
      </p>
      <button
        onClick={onAdjustFilters}
        className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center gap-2"
      >
        <Icon name="SlidersHorizontal" size={20} />
        Adjust Filters
      </button>
    </div>
  );
};

export default EmptyState;